export const toTrueOrFalse = (mode) => {
  if (mode === true) {
    return 'SIM';
  } else if (mode === false) {
    return 'NÂO';
  }
};
